import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

interface HomepageSectionProps extends ComponentProps<"section"> {
  background?: "default" | "muted";
}

export function HomepageSection({
  background = "default",
  className,
  ...props
}: HomepageSectionProps) {
  return (
    <section
      className={cn(
        "border-t py-20 md:py-28",
        background === "muted" ? "bg-muted/70" : "bg-background",
        className,
      )}
      {...props}
    />
  );
}
